
import React, { useEffect, useState, } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { Grid, Button, Input } from 'semantic-ui-react';
import './resource_master.css';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import axios from 'axios';


import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { baseUrl } from '../../../services/common/credentials';
import { port } from '../../../services/auth-service/authService';


var local_host = baseUrl + port;


const StickyHeadTable = ({ data }) => {
  const [page, setPage] = useState(0);
  const [tabId, setTabId] = useState(1);
  const [rowdata, setRowdata] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formCreate, setFormCreate] = useState(true);
  const [iskeys, setiskeys] = useState([]);
  const [formValues1, setFormValues1] = useState({})

  const [formValues, setFormValues] = useState({});

  const [fieldlist, setfieldlist] = useState([]);

  const intColumnDefs = React.useMemo(() => {
    if (rowdata?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(rowdata[0]);
      console.log(keys);
      setiskeys(keys);
      const model_names = {};
      keys.map((key) => {
        formValues1[key] = ''
      });
      setFormValues1(formValues1);
      setFormValues(formValues1);
      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [
        {
          id: '',
          label: '',
          minWidth: 5
        },
        ...keys.map((key) => ({
          id: key,
          label: key,
          minWidth: 25
        })),
        // {
        //     id: 'actions',
        //     label: 'Actions',
        //     minWidth: 15
        // },

      ];

      return intColumnDefs;
    }
    return [];
  }, [rowdata]);

  let handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    })
  }

  const makeapicall = async (url) => {
    try {
      console.log('called', url);
      const response = await fetch(url);
      const data = await response.json();
      console.log('data' + JSON.stringify(data));
      setRowdata(data['data_out']);
      setfieldlist(data['types_of_data']);
    }
    catch (e) {
      console.log(e);

    }
  }

  let handleSubmit = (event) => {
    event.preventDefault();
    let url;
    console.log('formValues', formValues);
    console.log('formCreate', formCreate);
    console.log('tabId', tabId);

    if (formCreate == true) {
      switch (tabId) {
        case 1:
          url = local_host + `/api/v2/user_modules/api/create/Tenants/`;
          makeapicall(url);
          break;
        case 2:
          url = local_host + `/api/v2/user_modules/api/create/Groups/`;
          makeapicall(url);
          break;
        case 3:
          url = local_host + `/api/v2/user_modules/api/create/Entities/`;
          makeapicall(url);
          break;
        case 4:
          url = local_host + `/api/v2/user_modules/api/create/ExternalEntities/`;
          makeapicall(url);
          break;
        case 5:
          url = local_host + `/api/v2/user_modules/api/create/Process/`;
          makeapicall(url);
          break;
        case 6:
          url = local_host + `/api/v2/user_modules/api/create/Users/`;
          makeapicall(url);
          break;
        case 7:
          url = local_host + `/api/v2/user_modules/api/create/UserRoles/`;
          makeapicall(url);
          break;
        case 8:
          url = local_host + `/api/v2/user_modules/api/create/Divisions/`;
          makeapicall(url);
          break;

        default:
          break;
      }

    } else {
      switch (tabId) {
        case 1:
          url = local_host + `/api/v2/user_modules/api/update/Tenants/`;
          makeapicall(url);
          break;
        case 2:
          url = local_host + `/api/v2/user_modules/api/update/Groups/`;
          makeapicall(url);
          break;
        case 3:
          url = local_host + `/api/v2/user_modules/api/update/Entities/`;
          makeapicall(url);
          break;
        case 4:
          url = local_host + `/api/v2/user_modules/api/update/ExternalEntities/`;
          makeapicall(url);
          break;
        case 5:
          url = local_host + `/api/v2/user_modules/api/update/Process/`;
          makeapicall(url);
          break;
        case 6:
          url = local_host + `/api/v2/user_modules/api/update/Users/`;
          makeapicall(url);
          break;
        case 7:
          url = local_host + `/api/v2/user_modules/api/update/UserRoles/`;
          makeapicall(url);
          break;
        case 8:
          url = local_host + `/api/v2/user_modules/api/update/Divisions/`;
          makeapicall(url);
          break;

        default:
          break;
      }

    }
    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formValues)
    }).then((result) => {
      result.json().then((resp) => {
        console.log(resp);
        if (resp.message === 'Object updated successfully' || resp.message === 'Object created successfully') {
          switch (tabId) {
            case 1:
              url = local_host + `/api/v2/user_modules/api/get_all/Tenants/`;
              makeapicall(url);
              break;
            case 2:
              url = local_host + `/api/v2/user_modules/api/get_all/Groups/`;
              makeapicall(url);
              break;
            case 3:
              url = local_host + `/api/v2/user_modules/api/get_all/Entities/`;
              makeapicall(url);
              break;
            case 4:
              url = local_host + `/api/v2/user_modules/api/get_all/ExternalEntities/`;
              makeapicall(url);
              break;
            case 5:
              url = local_host +  `/api/v2/user_modules/api/get_all/Process/`;
              makeapicall(url);
              break;
            case 6:
              url = local_host +  `/api/v2/user_modules/api/get_all/Users/`;
              makeapicall(url);
              break;
            case 7:
              url = local_host +  `/api/v2/user_modules/api/get_all/UserRoles/`;
              makeapicall(url);
              break;
            case 8:
              url = local_host +  `/api/v2/user_modules/api/get_all/Divisions/`;
              makeapicall(url);
              break;

            default:
              break;
          }
          // const url = `http://127.0.0.1:8000/api/v2/user_modules/api/get_all/Tenants/`;
          // makeapicall(url);
          setFormCreate(true);
          setFormValues(formValues1);
        }
      })
    })
    .catch((error) => {
      // Handle network errors or errors during parsing
      console.error('Fetch Error:', error);
    });
  }

  const getAllRecords = (newValue) => {
    let url = '';
    switch (newValue) {
      case 1:
        url = local_host +  `/api/v2/user_modules/api/get_all/Tenants/`;
        makeapicall(url);
        break;
      case 2:
        url = local_host +  `/api/v2/user_modules/api/get_all/Groups/`;
        makeapicall(url);
        break;
      case 3:
        url = local_host +  `/api/v2/user_modules/api/get_all/Entities/`;
        makeapicall(url);
        break;
      case 4:
        url = local_host +  `/api/v2/user_modules/api/get_all/ExternalEntities/`;
        makeapicall(url);
        break;
      case 5:
        url = local_host +  `/api/v2/user_modules/api/get_all/Process/`;
        makeapicall(url);
        break;
      case 6:
        url = local_host +  `/api/v2/user_modules/api/get_all/Users/`;
        makeapicall(url);
        break;
      case 7:
        url = local_host +  `/api/v2/user_modules/api/get_all/UserRoles/`;
        makeapicall(url);
        break;
      case 8:
        url = local_host +  `/api/v2/user_modules/api/get_all/Divisions/`;
        makeapicall(url);
        break;

      default:
        break;
    }
  }

  useEffect(() => {
    console.log('called first', data);

    let newValue = parseInt(data);
    setTabId(newValue);
    getAllRecords(newValue);
    // makeapicall(url);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function updateFormValues(row) {

    const updatedFormValues = { ...formValues };
    for (const key in row) {
      if (row.hasOwnProperty(key) && formValues.hasOwnProperty(key)) {
        // Check if the key exists in both the row and formValues
        updatedFormValues[key] = row[key]; // Update the value in the copy
      }
    }
    console.log('updatedFormValues', updatedFormValues);
    setFormValues(updatedFormValues); // Update the state with the new values
  }

  const EditActions = ({ row }) => {
    setFormCreate(false);
    updateFormValues(row);
    //setFormValues({action_id:row.action_id,action_name: row.action_name,action_category:row.action_category,action_description: row.action_description,action_details: row.action_details,restapi_address: row.restapi_address,task: row.task });
  };

  const DeleteActions = ({ row }) => {
    const keys = Object.keys(row); // Get an array of keys
    const firstKey = keys[0]; // Get the first key
    const firstValue = row[firstKey];
    console.log('firstValue', firstValue,firstKey);
    let url;
    switch (tabId) {
      case 1:
        url = local_host +  `/api/v2/user_modules/api/delete/Tenants/`;

        break;
      case 2:
        url = local_host +  `/api/v2/user_modules/api/delete/Groups/`;

        break;
      case 3:
        url = local_host +  `/api/v2/user_modules/api/delete/Entities/`;

        break;
      case 4:
        url = local_host +  `/api/v2/user_modules/api/delete/ExternalEntities/`;

        break;
      case 5:
        url = local_host +  `/api/v2/user_modules/api/delete/Process/`;

        break;
      case 6:
        url = local_host +  `/api/v2/user_modules/api/delete/Users/`;

        break;
      case 7:
        url = local_host +  `/api/v2/user_modules/api/delete/UserRoles/`;

        break;
      case 8:
        url = local_host +  `/api/v2/user_modules/api/delete/Divisions/`;

        break;
      default:
        break;
    }

    axios.delete(url + `${firstValue}/`)
      .then(res => {
        console.log(res);
        getAllRecords(tabId);
        // const url = `http://127.0.0.1:8000/api/v2/user_modules/api/get_all/Tenants/`;
        // makeapicall(url);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>

        <div className="form-inline row">
          {iskeys.map((fieldName, index) => (
            <div key={index} className="form-group col-md-3 mb-2">
              <label className="label1 mb-1">{fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} </label>
              <div className="input_group">
                {fieldlist && fieldlist.length > 0 ? (<input
                  type={fieldlist[index]}
                  className="resource_input"
                  name={fieldName}
                  value={formValues[fieldName] || ''}
                  onChange={handleChange}
                />):(<input
                  type='text'
                  className="resource_input"
                  name={fieldName}
                  value={formValues[fieldName] || ''}
                  onChange={handleChange}
                />)}
                
              </div>
            </div>
          ))}
        </div>

        {/* <div className="button-section">  
      {formCreate ? <Button type="submit" className="common_style_btn"></Button>:
        <Button variant="contained" type="submit" className="common_style_btn"></Button>}
      </div> */}
        <div className="text-right m-2" style={{float:'right'}}>
          {formCreate ? <button
            type="submit"
            className="btn btn-min-width mr-1 mb-1"
            style={{ background: 'var(--blue)', width: '7em', color: '#f3f4f6', marginRight: '1.2em' }}

          >
            Create
          </button> :
            <button
            type="submit"
              className="btn btn-min-width mr-1 mb-1"
              style={{ background: 'var(--blue)', width: '7em', color: '#f3f4f6', marginRight: '1.2em' }}

            >
              Save
            </button>}

        </div>
      </form>

      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 270 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow style={{ backgroundColor: 'rgb(233, 232, 217)' }}>
                {intColumnDefs.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    
                    className="resource_input header_column label1"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(rowdata) && rowdata.length > 0 ? (
                rowdata
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {intColumnDefs.map((column) => (
                          <TableCell className="cell_data" key={column.id}>
                            {row[column.id]}
                          </TableCell>
                        ))}
                        <TableCell className="cell_data">
                          <span onClick={(e) => EditActions({ row })}>
                            <i className='fa-solid fa-pen-to-square'></i>
                          </span>
                          <span style={{ marginLeft: '1em' }} onClick={(e) => DeleteActions({ row })}>
                            <i className='fas fa-trash'></i>
                          </span>
                        </TableCell>
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={intColumnDefs.length + 1}>No data available</TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10]}
          component="div"
          count={rowdata?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}



const ResourceMasterTabs = () => {
  const [value, setValue] = useState("1");
  const [rowData, setRowData] = useState(undefined);

  const [hideResultGrid, setHideResultGrid] = useState(true);
  const [tab, setTab] = useState(null);

  const makeAPICall = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      console.log('data' + data);
      setRowData(data);
      setHideResultGrid(false);
      // setColumnData(gridColumnDefs);

    }
    catch (e) {
      console.log(e);
      setHideResultGrid(false);
    }
  }

  const handleChange = (event, newValue) => {
    console.log('newValue' + newValue);
    let url = '';
    switch (newValue) {
      case 0:
        url = local_host + `/api/v2/user_modules/api/get_all/Tenants/}`;
        makeAPICall(url);
        break;
      case 1:
        url = local_host + `/api/v2/user_modules/api/get_all/Groups/`;
        makeAPICall(url);
        break;
      case 2:
        url = local_host + `/api/v2/user_modules/api/get_all/Tenants/`;
        makeAPICall(url);
        break;
      default:
        break;
    }
    setValue(newValue);
  };

  return (

    <Box>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Tenants" value="1" style={{fontSize:'15px'}}/>
            <Tab label="Groups" value="2" style={{fontSize:'15px'}}/>
            <Tab label="Entity" value="3" style={{fontSize:'15px'}}/>
            <Tab label="External Entity" value="4" style={{fontSize:'15px'}} />
            {/* <Tab label="Process" value="5" style={{fontSize:'15px'}} /> */}
            <Tab label="Users" value="6" style={{fontSize:'15px'}} />
            <Tab label="User Roles" value="7" style={{fontSize:'15px'}} />
            <Tab label="Divisions" value="8" style={{fontSize:'15px'}} />
          </TabList>
        </Box>
        <TabPanel value="1" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="2" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="3" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="4" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="5" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="6" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="7" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>
        <TabPanel value="8" style={{ backgroundColor: 'white' }}><StickyHeadTable data={value} /></TabPanel>

      </TabContext>
    </Box>

  );
}



const ResourceMaster = () => {

  return (

    <div className="side" style={{ padding: "10px" }}>
      <Grid columns='equal'>
        <Grid.Row style={{ backgroundColor: "#fff", borderRadius: "12px", marginTop: "10px" }}>
          <Grid.Column>
            <ResourceMasterTabs />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>

  );
}


export default ResourceMaster;